export { default } from "./InitialsAvatarView";
